/* ZTX-028/029/030 — Zeytex ortak betik (tema JS'inden bağımsız, defer yüklenir).
 * 1) [data-zt-hizli-sepet] ve [data-zt-urun-form] formlarını /cart/add.js ile gönderir; başarı/hata bildirimi gösterir,
 *    [data-zt-sepet-sayi] rozetlerini günceller. JS yoksa formlar normal POST ile /cart'a gider.
 * 2) Hata/timeout'ta otomatik tekrar YOK; kullanıcıya mesaj verilir.
 */
(function () {
  'use strict';
  var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function bildirim(metin, hata, baglanti) {
    var el = document.getElementById('zt-bildirim');
    if (!el) {
      el = document.createElement('div');
      el.id = 'zt-bildirim';
      el.className = 'zt-bildirim';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.className = 'zt-bildirim' + (hata ? ' zt-bildirim--hata' : '');
    el.setAttribute('role', hata ? 'alert' : 'status');
    el.textContent = metin;
    if (baglanti) {
      var a = document.createElement('a');
      a.href = baglanti.href; a.textContent = baglanti.metin;
      el.appendChild(a);
    }
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.hidden = true; }, hata ? 8000 : 5000);
  }
  window.ztBildirim = bildirim;

  function sayiGuncelle(sayi) {
    document.querySelectorAll('[data-zt-sepet-sayi]').forEach(function (el) {
      el.textContent = sayi;
      el.hidden = !(sayi > 0);
    });
    document.querySelectorAll('[data-zt-sepet-baglanti]').forEach(function (el) {
      el.setAttribute('aria-label', 'Sepet, ' + sayi + ' ürün');
    });
  }
  window.ztSepetSayi = sayiGuncelle;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-zt-hizli-sepet], [data-zt-urun-form]')) return;
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    var dugme = form.querySelector('[type="submit"]');
    if (dugme) { if (dugme.disabled) return; dugme.disabled = true; dugme.setAttribute('aria-busy', 'true'); }
    var veri = new FormData(form);
    var zaman = new AbortController();
    var t = setTimeout(function () { zaman.abort(); }, 15000);
    fetch(kok + 'cart/add.js', { method: 'POST', body: veri, headers: { Accept: 'application/json' }, signal: zaman.signal })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (s) {
        if (!s.ok) {
          // 422: stok yetersiz / varyant satılamıyor vb. Shopify açıklamasını göster.
          throw new Error((s.j && (s.j.description || s.j.message)) || 'Ürün sepete eklenemedi.');
        }
        return fetch(kok + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (sepet) {
        sayiGuncelle(sepet.item_count);
        bildirim('Ürün sepete eklendi. ', false, { href: kok + 'cart', metin: 'Sepete git' });
        form.dispatchEvent(new CustomEvent('zt:sepete-eklendi', { bubbles: true, detail: sepet }));
      })
      .catch(function (err) {
        bildirim(err.name === 'AbortError' ? 'Bağlantı zaman aşımına uğradı. Sepetinizi kontrol edip tekrar deneyin.' : err.message, true,
          { href: kok + 'cart', metin: ' Sepeti aç' });
      })
      .finally(function () {
        clearTimeout(t);
        if (dugme) { dugme.removeAttribute('aria-busy'); if (!dugme.hasAttribute('data-zt-kalici-pasif')) dugme.disabled = false; }
      });
  });
})();
